import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface Message {
  id: number | string
  senderName: string
  senderType: number
  message: string
  streaming: boolean
  user: string
  created_at?: string
  final?: boolean
  llm_provider?: string
  llm_model_name?: string
}

interface AdjudicationMessageState {
  messages: Message[]
  isConnected: boolean
  error: string | null
  isLoadingMessages: boolean
}

const initialState: AdjudicationMessageState = {
  messages: [],
  isConnected: false,
  error: null,
  isLoadingMessages: false,
}

const adjudicationMessageSlice = createSlice({
  name: 'adjudicationMessage',
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload
    },
    addMessage: (state, action: PayloadAction<Message>) => {
      if (action.payload.streaming) {
        // If it's a streaming message, update the last message if it exists
        if (state.messages.length > 0) {
          const lastMessage = state.messages[state.messages.length - 1]
          if (lastMessage.streaming) {
            lastMessage.message += action.payload.message
            if (action.payload.created_at !== undefined) {
              lastMessage.created_at = action.payload.created_at
            }
            if (action.payload.llm_provider !== undefined) {
              lastMessage.llm_provider = action.payload.llm_provider
            }
            if (action.payload.llm_model_name !== undefined) {
              lastMessage.llm_model_name = action.payload.llm_model_name
            }
            return
          }
        }
        // If no streaming message exists, add new one
        state.messages.push(action.payload)
      } else if (action.payload.final) {
        // Replace the last streaming message with the complete one
        if (
          state.messages.length > 0 &&
          state.messages[state.messages.length - 1].streaming
        ) {
          state.messages[state.messages.length - 1] = {
            ...action.payload,
            streaming: false,
          }
        } else {
          state.messages.push(action.payload)
        }
      } else {
        // Regular non-streaming message
        state.messages.push(action.payload)
      }
    },
    setMessages: (state, action: PayloadAction<Message[]>) => {
      state.messages = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
    },
    clearMessages: (state) => {
      state.messages = []
    },
    setIsLoadingMessages: (state, action: PayloadAction<boolean>) => {
      state.isLoadingMessages = action.payload
    },
  },
})

export const {
  setConnectionStatus,
  addMessage,
  setMessages,
  setError,
  clearMessages,
  setIsLoadingMessages,
} = adjudicationMessageSlice.actions

export default adjudicationMessageSlice.reducer
